import { NextRouter } from 'next/router'
import noop from 'lodash/noop'

import ENV_VARS from '@/config'
import { useDispatch } from '@/lib/redux'
import useCurrentSession from '@/hooks/use-current-session'
import useGetUserFlag, { Flag } from '@/hooks/use-get-user-flag'
import { AccountType, PlanName } from '@/features/Pricing/pricing-plans'

const { DASHBOARD_URL } = ENV_VARS
const app = `${DASHBOARD_URL}/listings`

const toApp = () => {
  if (typeof window === 'undefined') return
  window.location.href = app
}

type SetPlansProps = {
  downgradeToEssentials: () => Promise<void>
  handleReplaceIntendedPlan: (p: AccountType) => Promise<void>
  intendedPlanFlag?: Flag<PlanName>
}

type Bag = {
  setSubmitting: () => void
}

// Helper methods to set intended_plan flag
// and upgrade / downgrade
const useSetPlans = (router: NextRouter): SetPlansProps => {
  const dispatch = useDispatch()
  const session = useCurrentSession()
  const subscriptionId = session?.company_info?.subscription_id
  const intendedPlanFlag = useGetUserFlag<PlanName>('intended_plan')
  const downgradeToEssentialsExisting = async (setSubmitting = noop) => {
    const paymentPlan = 'essentials-plan-monthly'
    const accountType = 'essentials'
    const { error } = await dispatch.plans.subscribe({
      plan_name: paymentPlan,
      original_subscription_id: subscriptionId,
      change_plan_request: true
    })
    setSubmitting(false)
    if (error) return
    router.push({
      pathname: '/register/confirmation',
      query: { accountType }
    })
  }
  const handleReplaceIntendedPlan = async (plan: AccountType, bag?: Bag) => {
    const id = intendedPlanFlag?.id
    const isNewUser = !!id
    const setSubmitting = bag?.setSubmitting
    if (isNewUser) {
      await dispatch.flags.updateUserFlag({
        id,
        name: 'intended_plan',
        value: plan
      })
    }
    if (plan === 'essentials') {
      if (isNewUser) {
        toApp()
      } else {
        await downgradeToEssentialsExisting(setSubmitting)
      }
    } else {
      router.push({
        pathname: '/register',
        query: { accountType: plan }
      })
    }
  }
  const downgradeToEssentials = async () => {
    toApp()
  }
  return { handleReplaceIntendedPlan, downgradeToEssentials, intendedPlanFlag }
}

export default useSetPlans
